import { getValuable } from "@/utils/common/routeHelper/routeUrlUtills";
import { apiRequest } from "@/utils/common/serviceApiHelper/serviceApiUtils";
import { LangCodeTypeEnum } from "@/utils/enums/LangCodeEnum";

import type { RequestDestinationDisplayNameInterface } from "./destinationServiceInterface/destinationGetDisplayNameInterface.";
import { ResponseDestinationDisplayNameInterface } from "./destinationServiceInterface/destinationGetDisplayNameInterface.";
import { ResponseLocationInterface } from "./destinationServiceInterface/destinationGetLocationInterface";

class DestinationService {
  private baseUrl: string;

  private basePathV2: string;

  constructor(baseUrl: string) {
    this.baseUrl = baseUrl;
    this.basePathV2 = "v2/destination";
  }

  async getDisplayName(params: RequestDestinationDisplayNameInterface) {
    const paramsRemovedEmptyValue = getValuable(params);

    const queryParams = new URLSearchParams(paramsRemovedEmptyValue as any);

    const response = (await apiRequest(
      this.baseUrl,
      `${this.basePathV2}/GetDisplayName?${queryParams}`,
      "GET",
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      true,
    )) as any;

    return new ResponseDestinationDisplayNameInterface(response);
  }

  async getLocation(params: string | undefined) {
    if (params) {
      const response = (await apiRequest(
        this.baseUrl,
        `${this.basePathV2}/GetLocation?country=${params}`,
        "GET",
        undefined,
        false,
        "Accept-Language: EN",
      )) as any;
      return new ResponseLocationInterface(response);
    }
    return null;
  }

  async getDisplayNameByLang(
    params: RequestDestinationDisplayNameInterface,
    lang: string,
  ) {
    const paramsRemovedEmptyValue = getValuable(params);

    const queryParams = new URLSearchParams(paramsRemovedEmptyValue as any);
    const response = (await apiRequest(
      this.baseUrl,
      `${this.basePathV2}/GetDisplayName?${queryParams}`,
      "GET",
      undefined,
      false,
      lang || LangCodeTypeEnum.EN,
      undefined,
      undefined,
      true,
    )) as any;

    return new ResponseDestinationDisplayNameInterface(response);
  }

  async getDisplayNameEn(params: RequestDestinationDisplayNameInterface) {
    const queryParams = new URLSearchParams(params as any);

    const response = (await apiRequest(
      this.baseUrl,
      `${this.basePathV2}/GetDisplayName?${queryParams}`,
      "GET",
      undefined,
      false,
      LangCodeTypeEnum.EN,
      undefined,
      undefined,
      true,
    )) as any;

    return new ResponseDestinationDisplayNameInterface(response);
  }
}

export default DestinationService;
